const EVENT_NAME = "criteoAdvertDeliveryResponse";

const recordDeliveryResponse = ({
  whitelistCount,
  returnedCount,
  intersectionCount,
  hasOnLoadBeacon,
  hasOnViewBeacon,
  isSearchPage,
}) => {
  window.NREUM?.addPageAction?.(EVENT_NAME, {
    whitelistCount,
    returnedCount,
    intersectionCount,
    hasOnLoadBeacon,
    hasOnViewBeacon,
    isSearchPage,
  });
};

export default recordDeliveryResponse;
